<template>
  <panel :title="data.code">
    <div class="row">
      <div class="col-12">
        <w-textarea :model="$schema.description" />
      </div>

      <div class="col-12">
        <w-select :model="$schema.valueType" :values="valueTypes" />
      </div>

      <div class="col-12 mt-2">
        <w-monaco v-if="$schema.valueType.$model === SettingValueType.JSON" language="json" :model="$schema.value" />

        <w-radio-list
          v-else-if="$schema.valueType.$model === SettingValueType.BOOLEAN"
          :model="$schema.value"
          :values="booleanValues"
        />

        <attachment-setting v-else-if="$schema.valueType.$model === SettingValueType.ATTACHMENT" />

        <w-datepicker v-else-if="$schema.valueType.$model === SettingValueType.DATE" :model="$schema.date" />

        <structure-node-mapping-setting
          v-else-if="$schema.valueType.$model === SettingValueType.STRUCTURE_NODE_MAPPING"
          :value="$schema.value"
        />

        <w-input v-else :model="$schema.value" />
      </div>

      <div class="col-12 mt-2">
        <w-select :model="$schema.entityType" :values="entityTypes" />
      </div>

      <div class="col-12 mt-2">
        <w-input :model="$schema.entityId" />
      </div>
    </div>

    <div slot="footer">
      <w-button class="btn-secondary" text="Wstecz" @click="goToList" />

      <w-button class="btn-primary float-right" text="Zapisz" @click="update" />
    </div>
  </panel>
</template>

<script>
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import AttachmentSetting from '@/components/formComponents/setting/AttachmentSetting';
import { EntityType } from '@/enums/entityType.enum';
import { Errors } from '@/enums/errors.enum';
import { SettingValueType } from '@/enums/settingValueType.enum';
import { formMixin } from '@/mixins/form';
import schema from '@/schemas/setting.schema';
import StructureNodeMappingSetting from '@/components/formComponents/setting/StructureNodeMappingSetting.vue';

// @vuese
// Edycja ustawienia
// @group setting
export default {
  components: { Panel, AttachmentSetting, StructureNodeMappingSetting },
  mixins: [formMixin],
  schema,
  data() {
    return {
      model: {},
      valueTypes: [
        { value: SettingValueType.BOOLEAN, text: 'Prawda/Fałsz' },
        { value: SettingValueType.JSON, text: 'JSON' },
        { value: SettingValueType.DATE, text: 'Data' },
        { value: SettingValueType.HTML, text: 'HTML' },
        { value: SettingValueType.ATTACHMENT, text: 'Załącznik' },
        { value: SettingValueType.NUMBER, text: 'Numeryczna' },
        { value: SettingValueType.TEXT, text: 'Tekstowa' },
        { value: SettingValueType.STRUCTURE_NODE_MAPPING, text: 'Mapowanie jednostek oświatowych' }
      ],
      entityTypes: [
        { value: undefined, text: 'Wybierz' },
        { value: EntityType.PROCEDURE, text: 'Procedura' },
        { value: EntityType.DOCUMENT, text: 'Wniosek' },
        { value: EntityType.MODULE, text: 'Moduł' },
        { value: EntityType.STAGE, text: 'Etap' },
        { value: EntityType.SCHEMA, text: 'Schema' }
      ],
      booleanValues: [
        { value: 'true', text: 'Prawda' },
        { value: 'false', text: 'Fałsz' }
      ],
      SettingValueType
    };
  },
  computed: {
    ...mapState({
      data: state => state.setting.data
    })
  },
  mounted() {
    this.$schema.$setData(this.data);
  },
  methods: {
    // @vuese
    // Zapisz ustawienie
    update() {
      if (this.$schema.$validateAll().length > 0) {
        return;
      }
      this.$store
        .dispatch('setting/update', { id: this.data.id, ...this.$schema.$getData() })
        .then(() => {
          this.goToList();
        })
        .catch(error => this.$store.dispatch('notifyError', { title: Errors.SETTING_CANNOT_UPDATE }));
    },
    // @vuese
    // Przenieś na listę ustawień
    goToList() {
      this.$router.push({ name: 'settingList' });
    }
  }
};
</script>
